import { Button, Grid, TextField } from '@mui/material';
import styled from 'styled-components';

import CommonComponentStyle from 'commons/styles/basic-components.styles';

class InboundInvoiceApprovalItemPageStyle extends CommonComponentStyle {
  InvoiceMainInfoWrapper = styled(Grid)`
    margin: 16px 0;
  `;

  DocumentNumberText = styled(Grid)`
    font-size: 16px;
    font-weight: 700;
  `;

  InvoiceInfoText = styled(Grid)`
    font-size: 14px;
    color: ${this.colors.PRIMARY_GRAY};
    padding-top: 1.5px;
    font-weight: 700;
  `;

  ContentWrapper = styled.div`
    padding: 16px 0;
    padding-bottom: 80px;
  `;

  StickyFooterWrapper = styled(this.FooterWrapper)`
    position: sticky;
    align-items: center;
    justify-content: center;
  `;

  SearchBar = styled(TextField)`
    width: 100%;
    margin-bottom: 8px !important;
  `;

  TaskItemWrapper = styled(Grid)`
    background-color: ${this.colors.LIGHTER_GRAY};
    padding: 8px 0;
    margin-top: 8px;
  `;

  TaskItemText = styled(Grid)`
    font-size: 14px;
    font-weight: 700;
    float: right;
    padding-top: 12px;
  `;

  FOCText = styled.span`
    border-radius: 8px;
    font-size: 10px;
    background: ${this.colors.LIGHTER_ORANGE};
    color: ${this.colors.PRIMARY_ORANGE};
    padding: 6px;
    width: fit-content;
  `;

  RowButton = styled(Button)`
    border-radius: 6px !important;
    border: 1px solid ${this.colors.PRIMARY_BLUE} !important;
    color: ${this.colors.PRIMARY_BLUE} !important;
    font-weight: 700 !important;
    background: ${this.colors.PRIMARY_WHITE} !important;
    &&.reject {
      color: ${this.colors.PRIMARY_RED} !important;
      border: 1px solid ${this.colors.PRIMARY_RED} !important;
    }
  `;

  ConfirmationButton = styled(Button)`
    width: 100% !important;
    padding: 5px 8px !important;
    border-radius: 6px !important;
    border: 1px solid ${this.colors.PRIMARY_BLUE} !important;
    background: ${this.colors.PRIMARY_BLUE} !important;
    color: ${this.colors.PRIMARY_WHITE} !important;
    font-weight: 700 !important;
    &:disabled {
      border: 1px solid ${this.colors.LIGHT_GRAY} !important;
      background: ${this.colors.LIGHT_GRAY} !important;
    }
  `;

  TitleWrapper = styled(Grid)`
    background: ${this.colors.LIGHTER_GRAY};
    padding: 16px;
    color: ${this.colors.PRIMARY_GRAY};
  `;

  ItemInformationWrapper = styled(Grid)`
    padding: 16px 16px 24px 16px;
  `;

  ItemInfoTitle = styled.p`
    color: ${this.colors.PRIMARY_GRAY};
    font-size: 12px;
    margin: 0;
    font-weight: 700;
  `;

  ItemInfoValue = styled.p`
    font-size: 14px;
    margin: 4px 0;
  `;
}

export default new InboundInvoiceApprovalItemPageStyle();
